export default __webpack_public_path__ + "static/media/W-2560-D.06aed19a.png";